import { LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { EvaluationReferrer } from 'src/core/constants/evaluation-referrer.constant';
import { NotificationType } from 'src/core/decorators/notification/notification-type.decorator';
import { NotificationDto } from 'src/core/models/notification/notification.dto';
import { CADatePipe } from 'src/core/pipes/ca-date.pipe';
import { NotificationService } from 'src/core/services/notification/notification.service';
import { CAToasterHelperService } from 'src/core/services/toaster/ca-toaster-helper.service';

@Component({
    selector: 'ca-conversation-evaluated-notification',
    templateUrl: './conversation-evaluated-notification.component.html',
    styleUrls: ['./conversation-evaluated-notification.component.scss'],
    standalone: false
})
@NotificationType('ConversationEvaluatedNotification', ConversationEvaluatedNotificationComponent)
export class ConversationEvaluatedNotificationComponent implements OnInit {
  data: NotificationDto;

  get payloadData(): any {
    return JSON.parse(this.data?.payload);
  }
  constructor(private notificationService: NotificationService, private router: Router) { }

  ngOnInit(): void { }

  static showNotification(
    notificationId: string,
    payload: string,
    toastr: ToasterService,
    localizationService: LocalizationService,
    toasterHelperService: CAToasterHelperService,
    notificationService: NotificationService,
    injector: Injector,
    caDatePipe: CADatePipe,
    router: Router
  ) {
    const parsedPayload = JSON.parse(payload);
    const message = localizationService.instant(
      'QualityManagement::ConversationEvaluatedToastrAndNotificationMessage',
      parsedPayload.conversationId
    );

    var toastrId = toastr.success(message);

    var toastrInstance = toasterHelperService.getToastById(toastrId);
    toastrInstance.onTap.pipe(take(1)).subscribe(() => {
      this.toasterClickedHandler(notificationService, notificationId, parsedPayload, router);
    });
  }

  static toasterClickedHandler(
    notificationService: NotificationService,
    notificationId: string,
    payload: any,
    router: Router
  ) {
    notificationService.markAsRead(notificationId).subscribe();
    this.navigateToEvaluation(payload, router);
    notificationService.markAsRead(notificationId);
  }

  static navigateToEvaluation(payloadData: any, router: Router) {
    const queryParams: any = {
      conversationId: payloadData.conversationId,
      isAutomatic: 'true',
      referrer: EvaluationReferrer.evaluationResult,
    };

    router.navigate(['quality', 'evaluation-result'], {
      queryParams: queryParams,
    });
  }

  onClick() {
    const parsedPayload = JSON.parse(this.data.payload);
    ConversationEvaluatedNotificationComponent.navigateToEvaluation(parsedPayload, this.router);
    this.notificationService.markAsRead(this.data.id);
  }
}
